import type { CreditBalanceCardProps } from './types';

export const CreditBalanceCard = ({
  balance,
  organizationName,
}: CreditBalanceCardProps) => {
  if (!balance) {
    return null;
  }

  const availableColor =
    balance.available > 0 ? 'text-[#3fb950]' : 'text-[#da3633]';

  return (
    <div className="bg-[#161b22] border border-[#30363d] rounded-lg p-4 mb-4">
      <h2 className="text-sm text-[#8b949e] uppercase tracking-wide mb-3">
        Organization Credit Balance{organizationName && ` — ${organizationName}`}
      </h2>

      <div className="flex gap-6">
        <div>
          <span className="text-[12px] text-[#8b949e] block">Total</span>
          <span className="text-lg font-bold text-[#c9d1d9]">
            {balance.totalCredits}
          </span>
        </div>
        <div>
          <span className="text-[12px] text-[#8b949e] block">Used</span>
          <span className="text-lg font-bold text-[#d29922]">
            {balance.usedCredits}
          </span>
        </div>
        <div>
          <span className="text-[12px] text-[#8b949e] block">Available</span>
          <span className={`text-lg font-bold ${availableColor}`}>
            {balance.available}
          </span>
        </div>
      </div>
    </div>
  );
};
